import { HustlerCompletedWorkout } from '../../dao/core-dao'
import { ImageFileId } from '../image/image-file-id'
import React from 'react'
import { stringUtil } from 'src/util/string-util'
import { timeUtil } from 'src/util/time-util'

interface CompletedByHustlerItemProps {
  hustlerCompletion: HustlerCompletedWorkout
}

export const CompletedByHustlerItem = ({ hustlerCompletion }: CompletedByHustlerItemProps): React.ReactElement => {
  const { hustler, metrics, completedAt, completedWorkoutCount } = hustlerCompletion

  return (
    <div className="flex gap-3 rounded-lg bg-white/5 p-3 transition-all hover:bg-white/10">
      <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-white/10 text-sm font-semibold text-white">
        {hustler.profilePhotoFileId ? (
          <ImageFileId fileId={hustler.profilePhotoFileId} className="h-12 w-12 rounded-full object-cover" />
        ) : (
          stringUtil.initials(hustler.name)
        )}
      </div>
      <div className="flex-1 overflow-hidden">
        <div className="flex items-baseline gap-2">
          <span className="truncate font-bold uppercase text-white">{stringUtil.getDisplayName(hustler)}</span>
          {completedWorkoutCount && completedWorkoutCount > 1 && (
            <span className="flex-shrink-0 text-xs text-primary">🔥 {completedWorkoutCount}x</span>
          )}
        </div>
        <div className="mt-1 text-xs text-white/60">
          completed this workout {completedAt && `• ${timeUtil.formatRelativeTime(completedAt, { addAgoSuffix: true })}`}
        </div>
        {metrics && (
          <div className="mt-2 flex gap-3 text-xs">
            {metrics.hustleScore > 0 && (
              <div className="flex items-center gap-1">
                <span className="text-white/50">Hustle:</span>
                <span className="font-semibold text-primary">{metrics.hustleScore}</span>
              </div>
            )}
            {metrics.calories > 0 && (
              <div className="flex items-center gap-1">
                <span className="text-white/50">Cal:</span>
                <span className="font-semibold text-white">{metrics.calories}</span>
              </div>
            )}
            {metrics.heartRate > 0 && (
              <div className="flex items-center gap-1">
                <span className="text-white/50">HR:</span>
                <span className="font-semibold text-white">{Math.round(metrics.heartRate)}</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
